import createDeeplinkUrlConfiguration from '@root/triage/src/api/create-deeplink-url/create-deeplink-url-configuration';
import useSafeNetworkRequest from '@root/core/src/hooks/use-safe-network-request';
import { useMemo } from '@root/vendor/react';

export default function useCreateDeeplinkUrl(callback) {
  const configuration = useMemo(createDeeplinkUrlConfiguration, [createDeeplinkUrlConfiguration]);
  return useSafeNetworkRequest(configuration, callback);
}
